import { render, staticRenderFns } from "./BracketsDoubleEllimination.vue?vue&type=template&id=2ecd2598&scoped=true"
import script from "./BracketsDoubleEllimination.vue?vue&type=script&lang=js"
export * from "./BracketsDoubleEllimination.vue?vue&type=script&lang=js"
import style0 from "./BracketsDoubleEllimination.vue?vue&type=style&index=0&id=2ecd2598&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd2598",
  null
  
)

export default component.exports